import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/design-system/card-shell')({
  component: () => <Navigate to="/design-system/card" />,
});
